import script from "./association.vue?vue&type=script&setup=true&lang=js"
export * from "./association.vue?vue&type=script&setup=true&lang=js"

import "./association.vue?vue&type=style&index=0&id=355d1f0c&lang=scss"

const __exports__ = script;

export default __exports__